import React from "react";

export const DropShadowFilter: React.FC = () => (
    <>
        <filter id="dropshadow" height="130%">
            <feGaussianBlur stdDeviation="4" result="coloredBlur" />
            <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
    </>
);
